/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleGradeResultGrade } from './moduleGradeResultGrade';
import type { CategoryGradeResult } from './categoryGradeResult';

/**
 * Canonical module grade result returned by the backend aggregator.
 */
export interface ModuleGradeResult {
  grade: ModuleGradeResultGrade;
  categories: CategoryGradeResult[];
}
